import React from 'react';
import { SlidePage } from '../index';
// import marcaChile from '../imgs/marca_chile_rojo.png';
import VocationLogo from '../imgs/vocation_junior_color.png';
import EdumetricsLogo from '../imgs/edumetrics_logo_color_sm.png';

const BackCover = ({ user, background, ...rest }) => {
  return (
    <SlidePage background={background} {...rest}>
      {/* <div className='logo-wrapper'>
        <img src={VocationLogo} alt='edumetrics vocation one logo' />
      </div> */}

      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          // background: 'red',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <div className='logo-wrapper'>
          <img
            src={VocationLogo}
            alt='edumetrics vocation one logo'
            style={{ width: 300 }}
          />
        </div>
        <div style={{ marginTop: 6, textAlign: 'center' }}>
          <div>contacto@edumetrics.cl</div>
          <div><strong>www.edumetrics.cl</strong></div>
        </div>
      </div>

      {/* <div
        style={{
          position: 'absolute',
          bottom: 265, // 221,
          right: '397px', // half of page width
          height: 'auto',
          width: 180,
          marginRight: -90
        }}
      >
        <img
          src={marcaChile}
          alt='marca chile'
          style={{
            width: 'inherit',
            height: 'auto'
          }}
        />
      </div> */}
      <div
        style={{
          position: 'absolute',
          width: '100%',
          bottom: 6,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <div
          className='logo-wrapper'
          style={{
            marginBottom: -16
          }}
        >
          <img
            src={EdumetricsLogo}
            alt='edumetrics vocation one logo'
            style={{ width: 200 }}
          />
        </div>
        <p>{new Date().getFullYear()} © Edumetrics</p>
      </div>
    </SlidePage>
  );
};

export default BackCover;
